import script from "./upload-picture-list.vue?vue&type=script&setup=true&lang=js"
export * from "./upload-picture-list.vue?vue&type=script&setup=true&lang=js"

import "./upload-picture-list.vue?vue&type=style&index=0&id=d9d9ff30&lang=scss&scoped=true"

import exportComponent from "D:\\Code\\wisecard\\smart-tms-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9d9ff30"]])

export default __exports__